import api from './../libs/api';

const STORAGE_KEY = 'stripe_transactions';
const STORAGE_TIMESTAMP_KEY = 'stripe_transactions_timestamp';

export default {
  getTransactions: (forceRefresh = false) => {
    return new Promise((resolve, reject) => {
      // Check if we have cached data and if force refresh is not requested
      if (!forceRefresh) {
        const cachedData = localStorage.getItem(STORAGE_KEY);
        const timestamp = localStorage.getItem(STORAGE_TIMESTAMP_KEY);
        
        if (cachedData && timestamp) {
          // Return cached data
          resolve(JSON.parse(cachedData));
          return;
        }
      }

      // If no cache or force refresh, fetch from API
      api()
        .get('/stripe-transactions')
        .then(({ status, data }) => {
          if (status === 200) {
            // Store in localStorage with timestamp
            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
            localStorage.setItem(STORAGE_TIMESTAMP_KEY, Date.now().toString());
            resolve(data);
          }
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  clearCache: () => {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_TIMESTAMP_KEY);
  }
}; 